import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PropertyListener } from '@vsolv/dev-kit/rx';
import { Asset } from '@wsphere/assets/domain';
import { AssetService } from '@wsphere/assets/web';
import { Warranty } from '@wsphere/warranties/domain';
import { BehaviorSubject, combineLatest, map, switchMap } from 'rxjs';
import { getDaysUntilExpiry, getRemainingTermLabel } from './term-expiry.util';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-warranty-status-drop-down',
  templateUrl: './warranty-status-drop-down.component.html',
  standalone: false,
})
export class WarrantyStatusDropDownComponent {
  constructor(private assetSvc: AssetService) {}

  @Input() warrantyStatus?: Warranty.Status;

  // status label mapping for UI display
  getStatusLabel = Warranty.getStatusLabel;

  @PropertyListener('warrantyTermDuration') warrantyTermDuration$ = new BehaviorSubject<number | undefined>(undefined);
  @Input() warrantyTermDuration?: number;

  @Input() warrantyValidity?: string;

  @PropertyListener('warrantyStartDate') warrantyStartDate$ = new BehaviorSubject<Date | undefined>(undefined);
  @Input() warrantyStartDate?: Date;

  @Input() transactionCloseDate?: Date;

  @Input() propertySetId?: string;

  @PropertyListener('expiryDate') expiryDate$ = new BehaviorSubject<Date | undefined>(undefined);
  @Input() expiryDate?: Date;

  @PropertyListener('asset') asset$ = new BehaviorSubject<Asset.Model | undefined>(undefined);
  @Input() asset?: Asset.Model;

  offset = 0;
  isOpen = false;

  //number of days from current date that the warranty expires
  daysToExpiry$ = combineLatest([this.expiryDate$, this.warrantyStartDate$, this.warrantyTermDuration$]).pipe(
    map(([expiryDate, startDate, termDuration]) => getDaysUntilExpiry(expiryDate, startDate, termDuration))
  );

  remainingTermLabel = getRemainingTermLabel;

  propertyValues$ = this.asset$.pipe(
    switchMap(async asset => {
      if (!asset) return null;

      return (await this.assetSvc.getAssetValues(asset.id))?.value ?? null;
    })
  );

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}
